import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {ItineraryModel} from "../models/itinerary.model";

@Injectable({providedIn: 'root'})
export class ItinerariesChannelService extends EntitiesChannel<ItineraryModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "itineraries_changed";
  }

  getPartialChannelName(): String {
    return "itineraries_partial_changed";
  }

  getCreateChannelName(): String {
    return "itineraries_created";
  }

}
